import { classesBouton } from '@artosera/ui';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useDocuments } from '../../api/coffre.js';
import styles from './FactureDetailPage.module.css';

/** Monté uniquement sur une pièce émise pour qui peut ouvrir le coffre. */
export function PiecesDuCoffre({
  galerieSlug,
  factureId,
}: {
  galerieSlug: string;
  factureId: string;
}): JSX.Element {
  const { t } = useTranslation(['regie', 'commun']);
  const pieces = useDocuments(galerieSlug, { rattache: `facture:${factureId}`, parPage: 50 });
  const documents = pieces.data?.documents ?? [];
  return (
    <section className={styles.carte} aria-labelledby="facture-pieces-coffre">
      <h2 id="facture-pieces-coffre" className={styles.carteTitre}>
        {t('regie:ventes.fiche.piecesCoffreTitre')}
      </h2>
      {pieces.isLoading ? (
        <p className={styles.vide}>{t('commun:chargement')}</p>
      ) : pieces.isError ? (
        <p className={styles.vide}>{t('regie:ventes.fiche.piecesCoffreIndisponibles')}</p>
      ) : documents.length === 0 ? (
        <p className={styles.vide}>{t('regie:ventes.fiche.piecesCoffreAucune')}</p>
      ) : (
        <ul className={styles.listeAvoirs}>
          {documents.map((d) => (
            <li key={d.id}>
              <Link
                className={`${styles.lienAvoir} ${styles.lienPieceCoffre}`}
                to={`/${galerieSlug}/coffre/${d.id}`}
              >
                {d.titre}
              </Link>
            </li>
          ))}
        </ul>
      )}
      {pieces.data && pieces.data.pagination.total > documents.length ? (
        <p className={styles.vide}>
          {t('regie:ventes.fiche.piecesCoffreLimite', {
            nombre: documents.length,
            total: pieces.data.pagination.total,
          })}
        </p>
      ) : null}
      <Link className={classesBouton('secondary', 'sm')} to={`/${galerieSlug}/coffre`}>
        {t('regie:ventes.fiche.piecesCoffreOuvrir')}
      </Link>
    </section>
  );
}
